import { apiJson } from '../api';
import type { TuningInstruction } from '../types';

export async function getInstruction(channel: string): Promise<TuningInstruction | null> {
  try {
    return await apiJson<TuningInstruction>(
      `/api/tuning-instructions/channel/${encodeURIComponent(channel)}`
    );
  } catch {
    return null;
  }
}

export async function saveInstruction(channel: string, text: string): Promise<TuningInstruction> {
  return apiJson<TuningInstruction>(
    `/api/tuning-instructions/channel/${encodeURIComponent(channel)}`,
    {
      method: 'PUT',
      json: { text },
    }
  );
}

export async function deleteInstruction(channel: string): Promise<void> {
  await apiJson(
    `/api/tuning-instructions/channel/${encodeURIComponent(channel)}`,
    { method: 'DELETE' }
  );
}
